module.exports = __webpack_public_path__ + "img/me.aa20a193.png";